import { Schema } from "mongoose"
import type { SchemaTypeOptions } from "mongoose"

import type { LocalizedString } from "../zod/localizedString"
import { withLocalizedStringFallback } from "../zod/localizedString"


export function localizedStringField(
  options?: Omit<SchemaTypeOptions<LocalizedString>, "type">
): SchemaTypeOptions<LocalizedString> {
  const userGet = options?.get

  return {
    ...options,
    type: Schema.Types.Mixed,
    get: (value: unknown) => withLocalizedStringFallback(userGet ? userGet(value) : value),
  }
}
